import { ChatMessage2 } from '@cordic/chatmail-web';

export class ChatMessagesHasView extends ChatMessage2
{
  hasViewed: boolean;
}

export class ChatMessagesWithDate extends ChatMessagesHasView {
  date: string;

  toJSON()
  {
    let cJSON: any = {};

    cJSON.chatID = this.chatID;
    cJSON.hasViewed = this.hasViewed;
    cJSON.operator = this.operator;
    cJSON.options = this.options;
    cJSON.read = this.read;
    cJSON.text = this.text;
    cJSON.time = this.time;
    cJSON.type = this.type;

    return cJSON;
  }

}

export class DateWiseChatMessages
{
  date: string;
  messages: ChatMessagesWithDate[];
}
